export abstract class BaseInputModel {
  get headers(): Record<string, string> {
    return {}
  }
  get pathParams(): Record<string, string> {
    return {}
  }
}
